import { Finding, FindingCollection } from "../../Findings";
import { CategoryCollection, Category } from "../../Categories";
import { Id_category } from "../../api/Identifiers";
import { get_state, did_change, did_any_change } from "../../redux/State";
import { Dispatcher, dispatch_action } from "../../redux/Dispatcher";
import { Actions, Action } from "../../redux/Actions";
import { Keys } from "../../redux/Datastore";
import { Configuration } from "../../Configuration";
import { CssElement } from "../../css_utils";
import { print_findings } from "../../pdf_report";

let menu_rows_count: number = 0;

function append_menu_row(li: HTMLLIElement): void {
    if (li) {
        UI.menu_findings_content_list_ul.appendChild(li);
        menu_rows_count++;
    }
}

function li_from_html(html: string): HTMLLIElement {
    return <HTMLLIElement>$.parseHTML(html.trim())[0];
}

class UI {
    public static get menu_findings_content_list_ul(): HTMLUListElement {
        return <HTMLUListElement>document.getElementById("menu_findings_content_list");
    }
    public static get menu_findings_header(): HTMLElement {
        return document.getElementById("menu_findings_header");
    }
    public static toggle_selected(li: HTMLLIElement, is_selected: boolean) {
        if (is_selected) {
            if (!li.classList.contains("selected")) {
                li.classList.add("selected");
            }

        }
        else {
            li.classList.remove("selected");
        }
    }
    public static get menu_print_findings(): HTMLElement {
        return document.getElementById("menu_print_findings");
    }
}

function remove(array: any[], elementToRemove: any): any[] {
    return array.filter(function (el) {
        return el !== elementToRemove;
    });
}

export interface FindingsMenuItemJSON {
    label: string,
    idCategory: string,
    count: number,
    icon: string
}

function toggleFindings(findingCategory: number, toggle_state: boolean) {
    let menuItemAnchor = $(`#id_finding__${findingCategory}`);

    // toggle the menu item
    if (menuItemAnchor.parent().prop("tagName") === "LI") {
        menuItemAnchor.parent().toggleClass("selected", toggle_state);
    }
}

// it is assumed that the findings are already filtered down by floor
export function build_findings_menu_json(floor_findings: FindingCollection, categories: CategoryCollection): FindingsMenuItemJSON[] {
    let r: FindingsMenuItemJSON[] = [];
    let temp: any = {};
    floor_findings.findings.forEach((finding: Finding) => {
        let category_key: string = finding.category.toString();
        if (!temp[category_key]) {
            let category_label: string = category_key;
            let category: Category = categories.find(finding.category);
            if (category) {
                category_label = category.label;
            }
            temp[category_key] = <FindingsMenuItemJSON>{
                label: category_label,
                idCategory: category_key,
                count: 0,
                icon: finding.icon_url
            };
        }
        temp[category_key].count++;
    });

    Object.keys(temp).forEach((key: string) => {
        r.push(temp[key]);

    });

    return r;

}


function force_draw_findings_menu() {
    let findings_menu: FindingsMenuItemJSON[] = get_state().get_array(Keys.MENU_FINDINGS_CONTENT, []);
    let findings_selected: string[] = get_state().get_array(Keys.MENU_FINDINGS_SELECTED, []);
    document.getElementById("menu_findings_content_list").innerHTML = "";  // remove all findings from the menu before building the menu.
    menu_rows_count = 0;
    findings_menu.sort(function (a, b) {
        if (a.label < b.label)
            return -1;
        if (a.label > b.label)
            return 1;
        return 0;
    });

    findings_menu.forEach((menuItem: FindingsMenuItemJSON) => {
        let id_category: string = menuItem.idCategory;
        let menu_item_id: string = `id_finding__${id_category}`;

        var html = `
<li style='padding: 2px; padding-left: 15px; border-radius: 0px' class='list-group-item clearfix'>
<span>
    <a href='#' id='${menu_item_id}' class='waves-effect' id_category=${id_category}>
        <img src='${menuItem.icon}'  width='20' height='20' />
        <i class='material-icons'> ${menuItem.label}</i>
    </a>
</span>
<span class='badge'>${menuItem.count}</span>
</li>
`;

        append_menu_row(li_from_html(html));

        let anchor: HTMLAnchorElement = <HTMLAnchorElement>document.getElementById(`${menu_item_id}`);
        let li: HTMLLIElement = <HTMLLIElement>anchor.parentElement.parentElement;

        let isSelected: boolean = findings_selected.indexOf(id_category) > -1;
        if (isSelected) {
            li.classList.add("selected");
        }

        anchor.onclick = onclick_menu_item;

    });



    if (menu_rows_count > 0) {
        // TODO: Split the <a> tag such that the glyphicon can be styled to stay 
        //       black on hover. The text link should underline and look like a 
        //       clickable link.

        let select_all_html: string = `
        <li class='list-group-item' style='padding: 2px' >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a href='#' id='findings_menu_selectall_icon' >
            <span class= 'glyphicon glyphicon-check'></span>
        </a>
        <a href='#' id='findings_menu_selectall' >Select All</a>
        </li>`;

        let clear_all_html: string = `
        <li class='list-group-item' style="padding: 2px" >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="#" id="findings_menu_clear_icon">
            <span class= "glyphicon glyphicon-unchecked"></span>
        </a>
        <a href="#" id="findings_menu_clear">Clear All</a>
        </li>`;

        append_menu_row(li_from_html(select_all_html));
        document.getElementById("findings_menu_selectall").onclick = onclick_select_all;
        document.getElementById("findings_menu_selectall_icon").onclick = onclick_select_all;

        append_menu_row(li_from_html(clear_all_html));
        document.getElementById("findings_menu_clear").onclick = onclick_clear_all;
        document.getElementById("findings_menu_clear_icon").onclick = onclick_clear_all;

    }
    if (!Configuration.read_only_mode) {
        let add_finding_html: string = `
        <li class='list-group-item' style="padding: 2px" >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="#" id="findings_menu_new_icon"   >
            <span class= "glyphicon glyphicon glyphicon-plus"></span>
        </a>
        <a href="#" id="findings_menu_new"   >
            Create a new finding
        </a>
        </li>`;


        append_menu_row(li_from_html(add_finding_html));
        document.getElementById("findings_menu_new").onclick = onclick_create_new;
        document.getElementById("findings_menu_new_icon").onclick = onclick_create_new;
    }

    if (menu_rows_count == 0) {
        new CssElement(UI.menu_findings_header).visibility = false;
    }
    else {
        new CssElement(UI.menu_findings_header).visibility = true;
    }

    // show the Print PDF button
    if (!Configuration.isPdfPrint) {
        new CssElement(UI.menu_print_findings).visibility = false;
    }
    else {
        new CssElement(UI.menu_print_findings).visibility = true;
        UI.menu_print_findings.onclick = () => {
            print_findings();
        };
    }
}


export function draw_findings_menu() {
    if (!Configuration.findings_feature_enabled) {
        return;
    }
    if (did_change(Keys.MENU_FINDINGS_EXPANDED)) {
        let expanded: boolean = get_state().get_boolean(Keys.MENU_FINDINGS_EXPANDED);
        if (expanded) {
            $("#menu_findings_header_chevron").attr("class", "glyphicon glyphicon-chevron-down");
            $("#menu_findings_content").show(400);
        }
        else {
            $("#menu_findings_header_chevron").attr("class", "glyphicon   glyphicon-chevron-right");
            $("#menu_findings_content").hide(400);
        }
    }

    // if the menu findings content changed, redraw the findings menu
    if (did_any_change([Keys.KEY_STATE_FIRST_RUN,
        Keys.MENU_FINDINGS_CONTENT,
        Keys.ID_FLOOR,
    ])) {
        force_draw_findings_menu();
    }


    if (did_change(Keys.MENU_FINDINGS_SELECTED)) {
        let findings_selected: Id_category[] = get_state().selected_findings_categories;
        $("#menu_findings_content_list a").each(function (idx, finding_a) {
            let anchor: HTMLAnchorElement = <HTMLAnchorElement>finding_a;
            let finding_category: Id_category = Id_category.wrap(anchor.getAttribute("id_category"));
            if (finding_category) {
                let li: HTMLLIElement = <HTMLLIElement>anchor.parentElement.parentElement;  // the parent of the anchor is a span, the parent of the span is an li. Hence we use jquery parents(), not parent()
                UI.toggle_selected(li, findings_selected.includes(finding_category));
            }
        });
    }
}

function onclick_clear_all() {
    dispatch_action(Action.toggle_all_findings_categories(false));
}

function onclick_menu_item(this: HTMLElement, ev: MouseEvent): any {
    let anchor: HTMLAnchorElement = <HTMLAnchorElement>this;
    let id_category = Id_category.wrap(anchor.getAttribute("id_category"));
    if (id_category) {
        // we must get a fresh copy of the state b/c this function runs
        // in a completely different context.
        let was_selected: boolean = get_state().selected_findings_categories.includes(id_category);
        let is_selected: boolean = !was_selected;
        Dispatcher.dispatch_action(Action.toggle_finding_category_selected(id_category, is_selected));
    }
}

function onclick_select_all() {
    dispatch_action(Action.toggle_all_findings_categories(true));
}

function onclick_create_new() {
    Dispatcher.dispatch(Actions.SET_ADD_FINDINGS_STATE, true);
}

